/**
 *
 * CardActivityLogItem
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Context, ActivityType, Item, Time } from './CardData.styles';

function CardActivityLogItem({ time, context, type, ...rest }) {
  return (
    <Item disablePadding {...rest}>
      <Time>{time}</Time>
      <Context>{context}</Context>
      <ActivityType>{type}</ActivityType>
    </Item>
  );
}

CardActivityLogItem.propTypes = {
  time: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  context: PropTypes.node,
  type: PropTypes.node,
};

export default memo(CardActivityLogItem);
